function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.188 13.334H3.173a.811.811 0 01-.811-.811v-9.35a.81.81 0 01.811-.811h20.015c.449 0 .812.363.812.811v9.35a.811.811 0 01-.812.811z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.384 12.185l1.148 1.149h19.656a.811.811 0 00.812-.811v-9.35a.811.811 0 00-.812-.811H3.173a.811.811 0 00-.811.811v8.965l.022.047z",
  fill: "url(#paint1_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.971 12.117H1.956a.811.811 0 01-.811-.812V1.957a.81.81 0 01.81-.811h20.016a.81.81 0 01.811.811v9.35a.811.811 0 01-.81.81z",
  fill: "url(#paint2_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.167 10.968l1.148 1.149h19.656a.811.811 0 00.811-.812V1.957a.811.811 0 00-.81-.811H1.955a.811.811 0 00-.811.811v8.965l.022.047z",
  fill: "url(#paint3_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.827 10.972H.81a.811.811 0 01-.81-.811V.81A.81.81 0 01.811 0h20.016a.81.81 0 01.811.811v9.35a.811.811 0 01-.811.811z",
  fill: "url(#paint4_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.416 2.32A1.16 1.16 0 0119.36.848H2.278c.033.118.048.243.042.373A1.169 1.169 0 011.222 2.32c-.2.01-.39-.03-.559-.11v6.553a1.159 1.159 0 011.657.988 1.16 1.16 0 01-.042.373H19.36a1.16 1.16 0 011.615-1.361V2.209c-.168.08-.359.121-.56.11z",
  fill: "url(#paint5_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.995 7.85H14.68v1.242h4.315V7.851zm-8.176.445a2.81 2.81 0 100-5.619 2.81 2.81 0 000 5.62zM6.958 1.88H2.643v1.241h4.315V1.88z",
  fill: "#fff"
});

var _ref9 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 2.362,
  y1: 7.848,
  x2: 23.999,
  y2: 7.848,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#61DB99"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 14.024,
  y1: 11.653,
  x2: 13.275,
  y2: 8.07,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#009E74",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 1.144,
  y1: 6.631,
  x2: 22.782,
  y2: 6.631,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#61DB99"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 13.591,
  y1: 12.835,
  x2: 10.112,
  y2: -0.943,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#005841",
  stopOpacity: 0.5
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 0,
  y1: 5.487,
  x2: 21.637,
  y2: 5.487,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A7F3CE"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#61DB99"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 5.167,
  y1: -0.165,
  x2: 18.935,
  y2: 13.603,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#61DB99"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})));

var SvgCashIcon = function SvgCashIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 14,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCashIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash-icon.c55b158b.svg";
export { ForwardRef as ReactComponent };